import React from 'react';
import _ from 'lodash';

import {
  useBrandSettingsWidgetQuery,
  useSaveBrandMutation
} from 'generated/graphql';

import { fields } from 'iron-forge-react-modules';
import * as types from './types';



export interface IData {
  logoUrl: string;
  formState: types.IFormState;
}

export function useQuery(storeId: string) {
  const tuple = useBrandSettingsWidgetQuery({
    variables: {
      storeId
    }
  });

  return React.useMemo(
    () => {
      const data: IData = {
        logoUrl: tuple.data?.store?.logoUrl ?? '',
        formState: {
          storeName: tuple.data?.store?.name ?? '',
          primaryColorHex: _.replace(tuple.data?.store?.primaryColorHex ?? '', '#', ''),
          secondaryColorHex: _.replace(tuple.data?.store?.secondaryColorHex ?? '', '#', ''),
          buttonColorHex: _.replace(tuple.data?.store?.buttonColorHex ?? '', '#', '')
        }
      };

      return {
        ...tuple,
        data
      };
    },
    [tuple]
  );
}



export function useSaveStoreBrand(storeId: string) {
  const [fnMutate, tuple] = useSaveBrandMutation();

  const fnWrappedMutate = React.useCallback(
    (formState: types.IFormState) => {
      fnMutate({
        variables: {
          storeId,
          storeName: formState.storeName,
          primaryColorHex: `#${formState.primaryColorHex}`,
          secondaryColorHex: `#${formState.secondaryColorHex}`,
          buttonColorHex: `#${formState.buttonColorHex}`,
          logo: formState.logo ? fields.FileInputField.fileData2EncodedString(formState.logo) : undefined
        }
      });
    },
    [
      fnMutate,
      storeId
    ]
  );

  return React.useMemo(
    () => [
      fnWrappedMutate,
      {
        ...tuple,
        data: null
      }
    ] as const,
    [
      fnWrappedMutate,
      tuple
    ]
  );
}
